@if (guessing.enabled) {
  <app-button-group
    title="Guesses"
    class="h-100 w-100"
    [(selectedValue)]="match.guesses.selected"
    >
    @for ($guess of guessing.previews; track $guess) {
      <button
        [buttonGroupItem]="$index"
        class="guess-item heading-text fs-3"
      >{{$guess.text}}</button>
    }
  </app-button-group>
}
